// extracted by mini-css-extract-plugin
module.exports = {"cartIcon":"styles_cartIcon__2awZa","icon":"styles_icon__2vSF8","total":"styles_total__30qqs"};